const blue = {
  100: "#F1F6FE",
  200: "#E7F1FE",
  300: "#C9E0FD",
  400: "#9DC6FB",
  500: "#5A95FC",
  600: "#286DF6",
  700: "#184DB4",
  800: "#103C93",
  900: "#112F69",
  contrastDefaultColor: "#ffffff"
}

export default blue
